<template>
    <div class="container-fluid">
        <ToastTemplet :bus="toast"></ToastTemplet>
        <div class="row mt-5">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Trash Banks</h3>

                <div class="card-tools">
                    <input class="btn search_box" type="text" placeholder="Search" @keyup="searchit" v-model="search" aria-label="Search">
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                        <tr>
                            <th>NO</th>
                            <th>Bank Name</th>
                            <th>Bank Address</th>
                            <th>Restore</th>
                        </tr>
                        <tr v-for="(bank_master,i) in trash_Bank_master.data" :key="bank_master.BANK_ID">
                            <td>{{ i+1 }}</td>
                            <td> {{ bank_master.Bank_Name}} </td>
                            <td>{{ bank_master.Bank_Address }}</td>
                            <td>
                                <a href="#" @click="restore(bank_master.BANK_ID)" ><i class="fas fa-recycle green"></i></a>
                            </td>
                        </tr>
                        </table>
                    </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-md-9">
                                    <pagination :data="trash_Bank_master" @pagination-change-page="loadAndSearchTrashBank" :limit="this.$PaginationCounterLimit">
                                    <span slot="prev-nav">&lt; Previous</span>
                                    <span slot="next-nav">Next &gt;</span>
                                </pagination>
                            </div>
                            <div class="col-md-1 show-text">
                                Show
                            </div>
                            <div class="col-md-1 pagination">
                                <multiselect
                                    v-model="$PaginationLimit"
                                    :options="this.$PaginationOptions"
                                    :allow-empty="false"
                                    open-direction="top"
                                    :show-labels="false"
                                    @input="loadAndSearchTrashBank(1)"
                                    aria-required="true">
                                </multiselect>
                            </div>
                            <div class="col-md-1 entries-text">
                                Entries
                            </div>
                        </div>
                    </div>
                    </div>
                    <!-- /.card -->
                </div>
                </div><!-- /.row -->
    </div>
</template>

<script>
    import ToastTemplet from "../widget/toast";
    export default {
        components: { Multiselect,ToastTemplet },
        data(){
            return{
                toast: new Vue(),
                search:'',
                trash_Bank_master:{}
            }
        },
        created() {
            Fire.$on('searching',()=>{
                this.loadAndSearchTrashBank();
            })
            Fire.$on('AfterChangeBank',()=>{
                this.loadAndSearchTrashBank();
            });
        },
        mounted(){
            this.loadAndSearchTrashBank();
        },
        methods:{
            searchit: _.debounce(()=>{
                Fire.$emit('searching');
            },500),
            restore(BANK_ID){
                Swal.fire({
                    title: 'Are you sure Restore It?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, do it!'
                    }).then((result) => {
                        if(result.value){
                            axios.get('restoreBank/'+BANK_ID).then(()=>{
                                Fire.$emit('AfterChangeBank');
                                this.toast.$emit('SwalSuccess',"Success!", "Bank Restore Successfully");

                            }).catch(()=>{
                                this.toast.$emit('SwalWarning',"Failed!", "There was something wrong, Or Bank Is Already In Use");
                            })
                        }
                    })
            },
            loadAndSearchTrashBank(page = 1) {
                this.toast.$emit('ProgressBarLoading');
                axios
                    .get("loadAndSearchTrashBank?query=" + this.search +"&page=" + page + "&PaginationLimit="+ this.$PaginationLimit)
                    .then(({ data }) => {
                        this.trash_Bank_master = data,
                        this.toast.$emit('ProgressBarFinish')
                    })
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any Such User");
                    });
            },
        }
    }
</script>
